import { EmailSenderCard } from '../billing/EmailSenderCard.js';
import { ServiceKeysCard } from './ServiceKeysCard.js';

/**
 * Every provider key in one place (owner, 20 September 2026).
 *
 * They had grown up wherever they were first needed: Resend under the billing entity because it
 * sends invoices, the transcription and AI keys next to recording storage because that is where
 * they were built. Somebody looking for "where do I put a key" should not have to know which
 * feature asked for it first.
 *
 * PayFast stays with the legal entity it takes money for: it is not one key but a merchant account,
 * and it means nothing without the entity's own details beside it.
 */
export function ProviderKeysPage() {
  return (
    <>
      <div className="arc-page-head">
        <div>
          <h1 className="arc-h1">Provider keys</h1>
          <p className="arc-muted" style={{ marginTop: 3 }}>
            The outside services the platform uses. Keys are sealed when saved and never shown
            again.
          </p>
        </div>
      </div>

      <ServiceKeysCard />
      <EmailSenderCard resellerId={null} />

      <p className="arc-subtle" style={{ fontSize: 12 }}>
        A reseller's own email sender is on its Branding tab; PayFast is with the legal entity it
        collects for, under Billing.
      </p>
    </>
  );
}
